var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Topo-sort member tablegroup ids so bound groups precede binders.
 * Only BIND edges where the bound id is also a member are considered.
 */
export function sortMemberGroupsByBindings(memberGroupIds, loadGroup) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c;
        const members = new Set(memberGroupIds);
        const deps = new Map();
        for (const id of memberGroupIds) {
            const group = yield loadGroup(id);
            const bound = [];
            for (const boundId of Object.values(group.getBindings())) {
                if (members.has(boundId))
                    bound.push(boundId);
            }
            deps.set(id, bound);
        }
        const inDegree = new Map();
        const dependents = new Map();
        for (const id of memberGroupIds) {
            inDegree.set(id, 0);
            dependents.set(id, []);
        }
        for (const [binder, boundIds] of deps) {
            for (const boundId of boundIds) {
                inDegree.set(binder, ((_a = inDegree.get(binder)) !== null && _a !== void 0 ? _a : 0) + 1);
                dependents.get(boundId).push(binder);
            }
        }
        const queue = memberGroupIds.filter((id) => { var _a; return ((_a = inDegree.get(id)) !== null && _a !== void 0 ? _a : 0) === 0; });
        const sorted = [];
        while (queue.length > 0) {
            const id = queue.shift();
            sorted.push(id);
            for (const next of (_b = dependents.get(id)) !== null && _b !== void 0 ? _b : []) {
                const deg = ((_c = inDegree.get(next)) !== null && _c !== void 0 ? _c : 1) - 1;
                inDegree.set(next, deg);
                if (deg === 0)
                    queue.push(next);
            }
        }
        if (sorted.length !== memberGroupIds.length) {
            const stuck = memberGroupIds.filter((id) => !sorted.includes(id));
            throw new Error(`Circular BIND dependency among tablegroups: ${stuck.join(', ')}`);
        }
        return sorted;
    });
}
